<template>
  <nav class="dash-nav">
    <button
      v-for="tab in tabs"
      :key="tab.href"
      class="tab-pill"
      :class="{ active: isActive(tab.href) }"
      @click="router.visit(tab.href)"
    >
      {{ tab.label }}
    </button>
  </nav>
</template>

<script setup>
import { router, usePage } from "@inertiajs/vue3"

const page = usePage()

const tabs = [
  { label: "PROJECTS",   href: "/" },
  { label: "MODEL LAB",  href: "/model-lab" },
  { label: "BILLING",    href: "/billing" },
]

function isActive(href) {
  return page.url === href || page.url.startsWith(`${href}?`)
}
</script>

<style scoped>
.dash-nav {
  display: flex;
  padding: 0 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  gap: 2px;
}

.tab-pill {
  padding: 10px 14px;
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  color: rgba(232, 230, 227, 0.45);
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: -1px;
}

.tab-pill:hover { color: #e8e6e3; }

.tab-pill.active {
  color: #f5a623;
  background: rgba(245, 166, 35, 0.12);
  border-bottom-color: #f5a623;
}
</style>
